export const WorkoutPlayerSleeper = {
  bindings: {
    playing: '<',
    onPlay: '&',
    onPause: '&',
  },

  template: `
    <div class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header text-center">
            <h5 class="modal-title m-auto">
              Resume workout?
            </h5>
          </div>
          <div class="modal-footer justify-content-center">
            <button class="btn btn-lg btn-pill btn-primary-inverse"
              type="button"
              data-dismiss="modal">
              No
            </button>
            <button class="btn btn-lg btn-pill btn-primary"
              type="button"
              ng-click="$ctrl.resume()">
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>`,

  controller($element, $scope) {
    'ngInject';

    return {
      $onInit() {
        this.modal = $element.find('.modal');

        $(document).on('visibilitychange.sleeper', event => {
          $scope.$apply(() => this.visibilityChanged(event));
        });
      },

      $onDestroy() {
        $(document).off('visibilitychange.sleeper');
      },

      visibilityChanged(event) {
        if (event.target.hidden) {
          this.backgroundMode = this.playing;
        } else if (this.backgroundMode) {
          this.backgroundMode = false;
          this.onPause();
          this.show();
        }
      },

      show() {
        this.modal.modal();
      },

      resume() {
        this.onPlay();
        this.modal.modal('hide');
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/WorkoutPlayer/WorkoutPlayerSleeper.js